export default __webpack_public_path__ + "static/media/puce-01@2x.d16abf40.jpg";